import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import { bool, number, string } from "prop-types";

import apolloClient from "../../connection/apolloClient";
import HideUnhideListingComponent from "../HideUnhideListingComponent";

const App = props => (
  <ApolloProvider client={apolloClient}>
    <HideUnhideListingComponent {...props} />
  </ApolloProvider>
);

App.propTypes = {
  is_hidden: bool.isRequired,
  property_id: number.isRequired,
  property_type: string.isRequired
};

export default App;
